import back_picture from '../../assets/img/carPictures/back_picture.png';
import counter_picture from '../../assets/img/carPictures/counter_picture.png';
import dashboard_picture from '../../assets/img/carPictures/dashboard_picture.png';
import door_left_front from '../../assets/img/carPictures/door_left_front.jpg';
import door_left_rear from '../../assets/img/carPictures/door_left_rear.jpg';
import door_right_front from '../../assets/img/carPictures/door_right_front.jpg';
import door_right_rear from '../../assets/img/carPictures/door_right_rear.jpg';
import front_picture from '../../assets/img/carPictures/front_picture.png';
import inside_back_picture from '../../assets/img/carPictures/inside_back_picture.jpg';
import inside_front_picture from '../../assets/img/carPictures/inside_front_picture.png';
import left_side_picture from '../../assets/img/carPictures/left_side_picture.jpg';
import motor_picture1 from '../../assets/img/carPictures/motor_picture1.jpg';
import right_side_picture from '../../assets/img/carPictures/right_side_picture.jpg';
import three_quarters_back_left_picture from '../../assets/img/carPictures/three_quarters_back_left_picture.png';
import three_quarters_back_picture from '../../assets/img/carPictures/three_quarters_back_picture.png';
import three_quarters_front_picture from '../../assets/img/carPictures/three_quarters_front_picture.png';
import three_quarters_front_right_picture from '../../assets/img/carPictures/three_quarters_front_right_picture.png';
import three_quarters_left_back_picture from '../../assets/img/carPictures/three_quarters_left_back_picture.jpg';
import three_quarters_left_front_picture from '../../assets/img/carPictures/three_quarters_left_front_picture.jpg';
import three_quarters_right_front_picture from '../../assets/img/carPictures/three_quarters_right_front_picture.jpg';
import three_quarters_right_back_picture from '../../assets/img/carPictures/three_quarters_right_back_picture.jpg';
import trunk_picture from '../../assets/img/carPictures/trunk_picture.jpg';
import roof_reference from '../../assets/img/carPictures/roof_reference.png';
import wheels_front_tire_depth_picture from '../../assets/img/carPictures/wheels_front_tire_depth_picture.png';
import wheels_back_tire_depth_picture from '../../assets/img/carPictures/wheels_back_tire_depth_picture.png';
import paint_test_picture from '../../assets/img/carPictures/paint_test_picture.png';

export const listImages = {
  back_picture,
  counter_picture,
  dashboard_picture,
  door_left_front,
  door_left_rear,
  door_right_front,
  door_right_rear,
  front_picture,
  inside_back_picture,
  inside_front_picture,
  left_side_picture,
  motor_picture1,
  right_side_picture,
  three_quarters_back_left_picture,
  three_quarters_back_picture,
  three_quarters_front_picture,
  three_quarters_front_right_picture,
  three_quarters_left_back_picture,
  three_quarters_left_front_picture,
  three_quarters_right_front_picture,
  three_quarters_right_back_picture,
  trunk_picture,
  roof_reference,
  paint_test_picture,
  wheels_back_tire_depth_picture,
  wheels_front_tire_depth_picture,
};
